import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { enableScroll, disableScroll } from '../../services/body-scroll';
import styles from './full-screen-window.scss';

class FullScreenWindow extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  componentDidMount() {
    disableScroll();
  }

  componentWillUnmount() {
    enableScroll();
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default FullScreenWindow;



// WEBPACK FOOTER //
// ./app/components/full-screen-window/full-screen-window.js